import React, { Suspense, useMemo } from "react";

import { routes } from "./modules";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Loading from "./components/Loading";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { PageTransitionProvider, RouteReadyProbe } from "./components/PageTransition";

function App() {
  // Defer Three.js configuration to improve initial load performance
  React.useEffect(() => {
    // Use setTimeout to defer this to the next tick, reducing main thread blocking
    const timer = setTimeout(() => {
      import("three").then((THREE) => {
        THREE.ColorManagement.enabled = true;
      });
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  // Memoize routes to prevent unnecessary re-renders
  const memoizedRoutes = useMemo(() => {
    return routes.map((route, index) => (
      React.createElement(React.Fragment, { key: `route-${index}` },
        React.createElement(Route, {
          name: route.name,
          path: route.path,
          exact: route.exact,
          element: React.createElement(RouteReadyProbe, null, route.element)
        })
      )
    ));
  }, []);

  return (
    React.createElement(React.Fragment, null,
      // Provider lives OUTSIDE the route Suspense boundary so the transition
      // overlay keeps covering the screen while lazy route chunks load.
      React.createElement(PageTransitionProvider, null,
        React.createElement(Suspense, {
          fallback: React.createElement("div", { className: 'flex flex-col w-full max-h-full relative' },
            React.createElement("div", { className: 'flex bg-background min-h-screen' }, " "),
            React.createElement(Loading, {
              title: "Page loading",
              message: "Fetching data, please wait ..."
            }),
            React.createElement(Footer, null)
          )
        },
          React.createElement("div", { className: 'flex flex-col text-foreground box-border justify-between w-full h-max min-h-screen relative bg-background' },
            React.createElement(Navbar, null),
            React.createElement(ScrollToTop, null),
            React.createElement("div", { className: 'flex h-max w-full flex-col' },
              React.createElement(Routes, null,
                memoizedRoutes
              )
            ),
            React.createElement(Footer, null)
          )
        )
      )
    )
  );
}

export default App;